<template>
  <div class="bookingform-list">
    <h2>Booking CC List</h2>
    <button class="btn btn-primary mb-4" @click="addCurrencyConvert">Add New Booking CC</button>
    <SearchBox v-model="search" class="col-md-3 col-12" />
    <v-client-table
      :data="filteredCurrencyConverts"
      :columns="columns"
      :options="options"
      @row-click="showCurrencyConvert"
    ></v-client-table>
  </div>
</template>
<script>
  import SearchBox from "@/components/tools/SearchBox.vue";
  const api = window.api;
  
  export default {
    name: "BookingCCList",
    components: {
      SearchBox,
    },
    data() {
      return {
        currencyConverts: [],
        search: "",
        columns: ["id", "Reference", "ToCurrency", "ConvertValue", 'ModifiedUTC'],
        options: {
          headings: {
            Reference: "Reference",
            ToCurrency: "To Currency",
            ConvertValue: "Convert Value",
            ModifiedUTC: "Modified UTC",
          },
          sortable: ["id", "Reference", "ToCurrency", "ConvertValue", "ModifiedUTC"],
          filterable: ["id", "Reference", "ToCurrency", "ConvertValue", "ModifiedUTC"],
          perPage: 10,
          perPageValues: [10, 20, 50],
          skin: "table table-striped table-hover",
        },
      };
    },
    computed: {
      filteredCurrencyConverts() {
        if (!this.currencyConverts)  return []
        if (!this.search) return this.currencyConverts;
          
        const searchLower = this.search?.toLowerCase();
        return this.currencyConverts.filter((convert) => {
          return (
            convert.Reference?.toString().toLowerCase().includes(searchLower) ||
            convert.FromCurrency?.toLowerCase().includes(searchLower) ||
            convert.ToCurrency?.toLowerCase().includes(searchLower) ||
            convert.ConvertValue?.toString().includes(searchLower) ||
            convert.ModifiedUTC?.toString().toLowerCase().includes(searchLower)
          );
        });
      },
    },
    mounted() {
      this.fetchCurrencyConverts();
    },
    methods: {
      async fetchCurrencyConverts() {
        this.currencyConverts = (await api.get("/api/bookingcc/"))?.map(convert => ({
          ...convert,
          ModifiedUTC: new Date(convert.ModifiedUTC).toLocaleString(),
        })) || [];
      },
      showCurrencyConvert(data) {
        this.$router.push({ name: "bookingcc", params: { id: data.row.id } });
      },
      addCurrencyConvert() {
        this.$router.push({name: 'bookingcc', params: {id: null}})
      },
    },
  };
  </script>
  
  <style scoped>
  .bookingform-list {
    margin: 20px;
  }
  .mb-4 {
    margin-bottom: 16px;
  }
  </style>
  